import React from 'react';
import { Typography, Box } from '@mui/material';
import { ResumeContent } from './ResumeContent';
import { Experience, Education } from './data';

interface ResumeSectionProps {
  title: string;
  items: (Experience | Education)[];
  type: 'experience' | 'education';
}

export const ResumeSection = ({
  title,
  items,
  type,
}: ResumeSectionProps): React.ReactNode => {
  return (
    <Box sx={{ flex: { md: '0 0 50%' } }}>
      <Typography
        variant='h3'
        sx={{
          mb: 3,
          fontSize: { xs: '1.5rem', md: '1.8rem' },
          fontWeight: 'bold',
          color: 'primary.main',
        }}
      >
        {title}
      </Typography>

      {items.map((item, index) => (
        <ResumeContent
          key={index}
          title={item.title}
          company={
            type === 'experience' ? (item as Experience).company : undefined
          }
          institution={
            type === 'education' ? (item as Education).institution : undefined
          }
          date={item.date}
          content={item.content}
        />
      ))}
    </Box>
  );
};
